<template>
  <div class="chat-info">
    <div class="chat-info__title">
      {{ title }}
    </div>
    <div class="chat-info__text">
      <slot>{{ text }} </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Info',
    props: {
      title: String,
      text: String,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .chat-info {
    padding: 8px;
    background: $grey100;
    border-radius: 12px;
    color: $grey900;
    &__title {
      font-weight: bold;
      font-size: 14px;
    }
    &__text {
      font-weight: 500;
      font-size: 14px;
    }
  }
</style>
